import { GlobalConstants } from '../utils/app-constants';

export class BaseModuleState {

    public cacheVersion = GlobalConstants.CACHE_VERSION;

}
